import { Injectable } from '@angular/core';

import { BaseService } from './base.service';

@Injectable()
export class ActionPlanService {

  path = '/action-plan';

  constructor(private baseService: BaseService) {}

  getPaginated(init: number, end: number, filters: object) {
    return this.baseService.get(this.path, '', { init, end, ...filters });
  }

  getPaginatedByUser(init: number, end: number, filters: object) {
    return this.baseService.get(this.path, '/all-by-user', { init, end, ...filters });
  }

  getById (id) {
    return this.baseService.get(this.path,`${id}`)
  }

  doneActionPlan(id: number) {
    return this.baseService.post(this.path, `/${id}`, {id});
  }

  updateResponsible(id: number, responsible_id: number) {
    return this.baseService.get(this.path, '/update-responsible/' + id, { responsible_id });
  }

  exportCsv(filters: object) {
    return this.baseService.get(this.path, '/export/csv', filters);
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/action-plan.service.ts